module.exports = __webpack_public_path__ + "img/bg.888683ae.jpg";